import { createV2EventTracker } from '../util';
import {
  AnnotationDeletedAnalytics,
  AnnotationAnalytics,
  AnnotationSchema,
  BulkAnnotationDeletedAnalytics,
} from './types';

export const trackAnnotationCreated = createV2EventTracker<AnnotationAnalytics>(
  'Annotation Created',
  AnnotationSchema,
);

export const trackAnnotationUpdated = createV2EventTracker<AnnotationAnalytics>(
  'Annotation Updated',
  AnnotationSchema,
);

export const trackAnnotationDeleted =
  createV2EventTracker<AnnotationDeletedAnalytics>('Annotation Deleted');

export const trackBulkAnnotationDeleted =
  createV2EventTracker<BulkAnnotationDeletedAnalytics>('Bulk Annotation Deleted');

export const trackAnnotationLinkCopied = createV2EventTracker<AnnotationAnalytics>(
  'Annotation Link Copied',
  AnnotationSchema,
);
